import React, { useState, useRef, useEffect } from "react";
import { Image } from "react-bootstrap";
import { LayoutHome } from "../LayoutHome";
import { Text } from "rsuite";
import { useParams } from "react-router-dom";
import { getFirmaConsentimiento } from "../Services/PacientesServices";

export const AvisoPrivacidad = () => {
  const [idNegocio] = useState(JSON.parse(localStorage.getItem("auth")).id);
  const [negocio] = useState(
    JSON.parse(localStorage.getItem("auth")).consultorio,
  );
  const [firma, setFirma] = useState("");
  const [firmaRepre, setFirmaRepre] = useState("");
  const [idMedico, setIdMedico] = useState("");
  const [representante, setRepresentante] = useState("");
  const { idPaciente, paciente } = useParams();
  const initialized = useRef(false);

  const getFirma = async () => {
    await getFirmaConsentimiento(idNegocio, idPaciente, "Aviso")
      .then((res) => {
        setFirma(res.firmaPac);
        setIdMedico(res.idMedico);
        setFirmaRepre(res.firmaDr);
        setRepresentante(res.representante);
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      getFirma();
    }
  }, []);

  return (
    <div>
      <title>Aviso de Privacidad</title>
      <Image
        src={`/Images/Negocios/${idNegocio}/cornerImageHoja.png`}
        style={{
          width: "450px",
          position: "absolute",
          right: "0%",
          top: "0%",
          zIndex: "-1",
        }}
      />
      <div
        style={{
          marginLeft: "200px",
          marginTop: "50px",
          marginRight: "200px",
          marginBottom: "50px",
        }}
      >
        <div className="row mb-4">
          <div className="col-lg-3 col-md-4 col-sm-3">
            <Image
              src={`/Images/Negocios/${idNegocio}/Logo.png`}
              height={"80ox"}
            />
          </div>
          <div className="text-center col-lg-6 col-md-6 col-sm-6">
            <br></br>
            <br></br>
            <br></br>
            <Text>AVISO DE PRIVACIDAD</Text>
          </div>
          <div className="col-lg-3 col-md-3 col-sm-3"></div>
        </div>
        <div className="row mb-2">
          <div className="col" style={{ textAlign: "justify" }}>
            De acuerdo con Io Previsto en la *Ley Federal de Protección de Datos
            Personales", Unidad de Hemodiálisis SENEFRO S.C. se declara ser una
            empresa legalmente constituida de conformidad con las leyes
            mexicanas, con domicilio en Antonio Rosalea #204; y como responsable
            del tratamiento de sus datos personales, hace de su conocimiento que
            la información de nuestros clientes es tratada de forma
            estrictamente confidencial por to que, al proporcionar sus datos
            personales, tales como:
          </div>
        </div>
        <div className="row mb-2">
          <div className="col">
            <ol type="1" style={{ fontWeight: "bold" }}>
              <li>Nombre y/o razón social.</li>
              <li>Dirección.</li>
              <li>
                Registro Federal de Contribuyentes (Datos para facturaclón).
              </li>
              <li>Telèfonos de oficlna y móviles</li>
              <li>Correo Electrónico.</li>
            </ol>
          </div>
        </div>
        <div className="row mb-2">
          <div className="col">
            Estos serán utilizados única y exclusivamente para los siguientes
            fines:
          </div>
        </div>
        <div className="row mb-2">
          <div className="col" style={{ fontWeight: "bold" }}>
            <ol type="1">
              <li>Campañas de Fidelidad</li>
              <li>Información y Prestación de Servicios</li>
              <li>Actualización de la Base de Datos</li>
              <li>
                Cualquier finalidad ariáloga o compatible con las anteriores.
              </li>
            </ol>
          </div>
        </div>

        <div className="row mb-2">
          <div className="col" style={{ textAlign: "justify" }}>
            Para prevenir el acceso no autorizado a sus datos personales y con
            el fin de asegurar que la información sea utilizada para los fines
            establecidos en este aviso de privacidad, hemos establecido diversos
            procedimientos con la finalidad de evitar el uso o divulgación no
            autorizados de sus datos, permitiéndonos tratarłos debidamente. Así
            mismo, le informamos que sus datos personales pueden ser
            transmitidos para ser tratados por personas distintas a esta
            institución de salud. Todos sus datos personales son tratados de
            acuerdo a la legislación aplicable y vigente en el país, por ello le
            informamos que usted tiene en todo momento los derechos (ARCO) de
            acceder, rectificar, cancelar u oponerse al tratamiento que le damos
            a sus datos personales; derecho que podrź hacer valer a través de
            Oscar Israel Rodriguez Méndez encargado de la seguridad de datos
            personales en el Teléfono 33-31-75-06 y 33 14 10 74 69
          </div>
        </div>

        <div className="row mb-4">
          <div className="col" style={{ textAlign: "justify" }}>
            A través de estos canales usted podrá actualizar sus datos y
            especificar el medio por el cual desea recibir información, ya que,
            en caso de no contar con esta especificación de su parte, Unidad de
            hemodiálisis SENEFRO S.C. establecerá libremente el canal que
            considere pertinente para enviarle información. Este aviso de
            privacidad podrź ser modificado por Unidad de hemodiálisis SENERO
            S.C., dichas modificaciones serán oportunamente informadas a través
            de correo electrónico, teléfono, página web o cualquier otro medio
            de comunicación que determine para tal efecto.
          </div>
        </div>
        <br></br>
        <br></br>
        <div className="row">
          <div
            className="text-center col-lg-4 col-md-4 col-sm-4"
            style={{ fontWeight: "bold" }}
          >
            <img
              src={`Unidades/${idNegocio}/Expedientes/Pacientes/${idPaciente}/Consentimientos/${firma}`}
              alt="signature"
              style={{
                height: "200px",
                padding: "10px",
                zIndex: "-1",
              }}
            />
            <p>{paciente.toUpperCase()}</p>
          </div>
          <div className="col-lg-2 col-md-2 col-sm-2">&nbsp;</div>
          <div
            className="text-center col-lg-4 col-md-4 col-sm-4"
            style={{ fontWeight: "bold" }}
          >
            <img
              src={`Unidades/${idNegocio}/Medicos/${idMedico}/${firmaRepre}`}
              alt="signature"
              style={{
                height: "200px",
                padding: "10px",
                zIndex: "-1",
              }}
            />
            <p>{representante}</p>
          </div>
        </div>
        <div className="row mb-2">
          <div
            className="text-center col-lg-4 col-md-4 col-sm-4"
            style={{ borderTopStyle: "solid", borderWidth: "thin" }}
          >
            FIRMA Y NOMBRE DEL PACIENTE
          </div>
          <div className="col-lg-2 col-md-2 col-sm-2">&nbsp;</div>
          <div
            className="text-center col-lg-4 col-md-4 col-sm-4"
            style={{ borderTopStyle: "solid", borderWidth: "thin" }}
          >
            FIRMA Y NOMBRE DEL REPRESENTANTE LEGAL DE SENEFRO S.C.
          </div>
        </div>
      </div>
    </div>
  );
};
